"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAccumulator = createAccumulator;
function createAccumulator() {
    return {
        messages: [],
        toolDefinitions: [],
        toolDefinitionIndexByName: new Map(),
        unparsedKeys: {},
    };
}
